function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.476 19.063L17.74 2.889c-.444-1.252-2.146-1.158-2.465.133l-1.147 4.63a40.159 40.159 0 01-2.934 8.047L9.52 19.102c-.03.061-.058.126-.078.19C7.704 24.428 11.313 29 16.499 29c5.281 0 8.903-4.744 6.977-9.94v.003z",
    fill: props.color || 'black'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.476 19.063L17.74 2.889c-.444-1.252-2.146-1.158-2.465.133l-1.147 4.63a40.159 40.159 0 01-2.934 8.047L9.52 19.102c-.03.061-.058.126-.078.19C7.704 24.428 11.313 29 16.499 29c5.281 0 8.903-4.744 6.977-9.94v.003z",
    fill: props.color || 'black'
  }));
}
export default SvgTear;